import React from 'react';
// import { useNavigate, Link } from 'react-router-dom'

function Footer() {
    // const navigate = useNavigate();    

  return (
    <footer id="footer">
    <div className="container">
        <div className="footer-logo">
            <img src="/img/logo_footer.png" alt="(주)아토스 안전보건교육" />
        </div>
        <ul className="menu-list">
            <li><button>고객센터</button></li>
            <li><button>이용약관</button></li>
            <li><button>개인정보처리방침</button></li>
        </ul>
        <div className="footer-bottom">
            <address>
                <span>[08381] 서울특별시 구로구 디지털로 273 905호 (에이스 트윈 타워 2차) TEL : 02-3442-7111 FAX : 02-3442-2110</span>
                &nbsp; <span>사업자 등록번호 : 112-81-20633</span> &nbsp;
                <span>대표자 : 이태식</span>
            </address>
            <p className="copy">Copyright &copy; 2024 ATOS. ALL RIGHTS RESERVED.</p>
        </div>
    </div>
    </footer>
  );
}

export default Footer;